/**
 * @generated SignedSource<<7322fdecc2db577f1cb581f993dd3334>>
 * @relayHash 0e768e393b30d02fefa70aea6ff331dc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fefb4d34fda4855a9da03cd56fbed1e14738ca4c05789a9e81445f95ef8d208c

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AgentProfileCardContainerQuery$variables = {
  agentAri: string;
  cloudId: string;
  fetchByIdentity: boolean;
  identityAccountId: string;
};
export type AgentProfileCardContainerQuery$data = {
  readonly agentStudio_agentById?: {
    readonly __typename: "AgentStudioAssistant";
    readonly AgentProfileCard_agentRef: {
      readonly " $fragmentSpreads": FragmentRefs<"AgentProfileCard_agentRef">;
    } | null;
    readonly id: string;
    readonly name: string | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly agentStudio_agentByIdentityAccountId?: {
    readonly __typename: "AgentStudioAssistant";
    readonly AgentProfileCard_agentRef: {
      readonly " $fragmentSpreads": FragmentRefs<"AgentProfileCard_agentRef">;
    } | null;
    readonly id: string;
    readonly name: string | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type AgentProfileCardContainerQuery = {
  response: AgentProfileCardContainerQuery$data;
  variables: AgentProfileCardContainerQuery$variables;
};
({
  "__relay_internal__pv__migrateagentavatarcomponenttoadsrelayprovider": migrateAgentAvatar_provider
} as {
  readonly __relay_internal__pv__migrateagentavatarcomponenttoadsrelayprovider: {
    readonly get: () => boolean;
  };
});

import migrateAgentAvatar_provider from './../../../migrate-agent-avatar-component-to-ads.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "agentAri"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchByIdentity"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "identityAccountId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "agentAri"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "name"
},
v8 = [
  (v5/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v6/*: any*/),
      (v7/*: any*/),
      {
        "fragment": {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "AgentProfileCard_agentRef"
            }
          ],
          "type": "AgentStudioAssistant"
        },
        "kind": "AliasedInlineFragmentSpread",
        "name": "AgentProfileCard_agentRef"
      }
    ],
    "type": "AgentStudioAssistant"
  }
],
v9 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "identityAccountId"
  }
],
v10 = [
  (v5/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v6/*: any*/),
      (v7/*: any*/),
      {
        "kind": "ScalarField",
        "name": "description"
      },
      {
        "kind": "ScalarField",
        "name": "icon"
      },
      {
        "kind": "ScalarField",
        "name": "identityAccountId"
      },
      {
        "condition": "__relay_internal__pv__migrateagentavatarcomponenttoadsrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "identityAccount",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isUser"
              },
              {
                "kind": "ScalarField",
                "name": "picture"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "appType"
                  }
                ],
                "type": "AppUser"
              },
              (v6/*: any*/)
            ]
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "externalConfigReference"
      },
      {
        "kind": "ScalarField",
        "name": "isFavourite"
      },
      {
        "kind": "ScalarField",
        "name": "conversationStarters"
      },
      {
        "kind": "ScalarField",
        "name": "creatorType"
      },
      {
        "kind": "ScalarField",
        "name": "forgeCreator"
      },
      {
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "kind": "ScalarField",
            "name": "accountId"
          },
          (v7/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "accountStatus"
              }
            ],
            "type": "AtlassianAccountUser"
          },
          (v6/*: any*/)
        ]
      },
      {
        "concreteType": "TeamV2",
        "kind": "LinkedField",
        "name": "authoringTeam",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "displayName"
          },
          {
            "kind": "ScalarField",
            "name": "profileUrl"
          },
          (v6/*: any*/)
        ]
      },
      {
        "concreteType": "AgentStudioAgentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "canEdit"
          },
          {
            "kind": "ScalarField",
            "name": "canDelete"
          }
        ]
      }
    ],
    "type": "AgentStudioAssistant"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v6/*: any*/)
    ],
    "type": "Node",
    "abstractKey": "__isNode"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "AgentProfileCardContainerQuery",
    "selections": [
      {
        "condition": "fetchByIdentity",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "agentStudio_agentById",
            "plural": false,
            "selections": (v8/*: any*/)
          }
        ]
      },
      {
        "condition": "fetchByIdentity",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v9/*: any*/),
            "kind": "LinkedField",
            "name": "agentStudio_agentByIdentityAccountId",
            "plural": false,
            "selections": (v8/*: any*/)
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__migrateagentavatarcomponenttoadsrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "AgentProfileCardContainerQuery",
    "selections": [
      {
        "condition": "fetchByIdentity",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "agentStudio_agentById",
            "plural": false,
            "selections": (v10/*: any*/)
          }
        ]
      },
      {
        "condition": "fetchByIdentity",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v9/*: any*/),
            "kind": "LinkedField",
            "name": "agentStudio_agentByIdentityAccountId",
            "plural": false,
            "selections": (v10/*: any*/)
          }
        ]
      }
    ]
  },
  "params": {
    "id": "fefb4d34fda4855a9da03cd56fbed1e14738ca4c05789a9e81445f95ef8d208c",
    "metadata": {},
    "name": "AgentProfileCardContainerQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__migrateagentavatarcomponenttoadsrelayprovider": migrateAgentAvatar_provider
    }
  }
};
})();

(node as any).hash = "7f56b7d6645b9220c953a6792948a3ba";

export default node;
